import { EOLocale } from 'eo-locale';
import React from 'react';
import Image from '@react/shared/Image';
const SuccessStoryCard = ({ title, content, image, url, prettyDate, pinText, }) => (React.createElement("div", { className: "grid-column" },
    React.createElement("a", { href: url, className: "card-uni", "data-aos": "animated" },
        React.createElement("div", { className: "card-uni__media" },
            React.createElement("div", { className: "card-uni__media-holder" },
                React.createElement(Image, { className: "card-uni__media-element", alt: title, cdn: true, height: 384, image: image, options: { gravity: 'north' }, width: 512 }))),
        React.createElement("div", { className: "card-uni__tag" },
            React.createElement("div", { className: "tag tag--blue" },
                React.createElement(EOLocale.Text, { id: "xperience.pintext.successstory" }))),
        React.createElement("div", { className: "card-uni__middle-band" },
            React.createElement("p", { className: "card-uni__middle-band-text" }, pinText)),
        React.createElement("div", { className: "card-uni__content" },
            React.createElement("h4", { className: "card-uni__title" }, title),
            React.createElement("p", { className: "card-uni__intro" }, content),
            React.createElement("div", { className: "card-uni__content-bottom" }, prettyDate && prettyDate != 'Jan 1, 0001' && (React.createElement("p", { className: "card-uni__date" }, prettyDate)))))));
export default SuccessStoryCard;
